export default {
    checkInOutLater: 'ยื่นคำขอลงเวลาย้อนหลัง',
    date: 'วันที่',
    forgetDate: 'วันที่ลืมลงเวลา',
    request: 'คำขอ',
    selectType: '- เลือกประเภทคำขอ -',
    checkInTime: 'เวลาเข้างาน',
    checkOutTime: 'เวลาออกงาน',
    selectTime: '- เลือกเวลา -',
    cancel: 'ยกเลิก',
    submit: 'ส่ง',
    invalidTime: 'เวลาไม่ถูกต้อง',
    fieldRequired: 'กรุณากรอกข้อมูล',
    fieldLessThanCharacters: 'ช่องนี้รองรับตัวอักษรไม่เกิน 255 ตัวอักษร',
    msgSuccessSingleDay: 'คำขอของคุณ วันที่ $startDate สำเร็จ',
    msgSuccessRange: 'คำขอของคุณ วันที่ $startDate ถึง $endDate สำเร็จ',
    cannotGetLineId: 'เกิดข้อผิดพลาด',
    reason: 'เหตุผล',
    reasonMsg: 'รายละเอียดคำขอของคุณ',
    approve: 'อนุมัติ',
    reject: 'ปฏิเสธ',
    back: 'ย้อนกลับ'
}
